import React from "react";
import { Tag, Icon, Popover, Button } from "antd";

const ColorByStatus = {
  PROCESSADO: "green",
  ERRO: "red",
  CRIADO: null,
  PROCESSANDO: "blue"
};

export const TableColumns = [
  {
    title: "STATUS",
    dataIndex: "status",
    key: "status",
    render: ([status, erro]) => (
      <div style={{ display: "flex", alignItems: "center" }}>
        <Tag color={ColorByStatus[status]}>{status}</Tag>
        {erro && (
          <Popover content={erro}>
            <Icon type="info-circle" style={{ color: "red" }} />
          </Popover>
        )}
      </div>
    )
  },
  {
    title: "ARQUIVO",
    dataIndex: "file",
    key: "file"
  },
  {
    title: "DATA CADASTRO",
    dataIndex: "dt_cadastro",
    key: "dt_cadastro"
  },
  {
    title: "DATA PROCESSAMENTO",
    dataIndex: "dt_processamento",
    key: "dt_processamento"
  },
  {
    title: "RESULTADO",
    dataIndex: "saida",
    key: "saida",
    render: saidaLink => (
      <a href={saidaLink} target="_blank">
        <Button type="ghost" icon="download" size="small">
          Baixar
        </Button>
      </a>
    )
  }
];



// WEBPACK FOOTER //
// ./src/pages/Contratos/AtualizacaoParcelas/table-columns.js